<template>
	<div class="IncidenciasNueva">
		<md-layout md-flex="100" md-align="center" class="m-t-24">
			<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="50" md-flex-large="30" md-flex-xlarge="20">
				<md-card class="w-100">
					<md-card-header>
						<div class="md-title">Registrar incidencia</div>
						<div class="md-subhead">Por favor llene todos los campos</div>
					</md-card-header>
					<md-card-content>
						<md-input-container v-bind:class="{ 'md-input-invalid': v.v_id_pun }">
							<label for="id_pun_ipu">Punto</label>
							<md-select name="id_pun_ipu" id="id_pun_ipu" v-model="incidencia.id_pun_ipu" required>
								<md-option v-for="p in puntos" :value="p.id_pun" :key="p.id_pun" >
									{{ p.nombre_pun }}
									<span><small>, {{ p.nombre.toUpperCase()}} </small></span>
								</md-option>
							</md-select>
						</md-input-container>
						<md-input-container v-bind:class="{ 'md-input-invalid': v.v_obs }">
							<label>Observaciones</label>
							<md-textarea v-model="incidencia.obs_ipu" required></md-textarea>
						</md-input-container>
					</md-card-content>
					<md-card-actions>
						<md-button @click.native="irAIncidencias()">Cancelar</md-button>
						<md-button @click.native="registrarIncidencia()">Registrar</md-button>
					</md-card-actions>
				</md-card>
			</md-layout>
		</md-layout>
	</div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "IncidenciasNueva",
  methods: {
    irAIncidencias() {
      this.$router.push("/incidencias");
    },
    obtenerPuntos() {
      this.$http
        .post("puntos", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "puntos" in response.body) {
              this.puntos = response.body.puntos;
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para obtener los puntos.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    registrarIncidencia() {
      if (this.validarCamposIncidencia()) {
        this.$http
          .post("incidencias/guardar", {
            token: this.$session.get("token"),
            incidencia: this.incidencia
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right"
                });
                this.irAIncidencias();
              }
            },
            response => {
              Snackbar.show({
                text:
                  "No se pudo establecer conexión con el servidor para guardar las incidencias.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarCamposIncidencia() {
      !this.incidencia.obs_ipu ? (this.v.v_obs = true) : (this.v.v_obs = false);
      !this.incidencia.id_pun_ipu
        ? (this.v.v_id_pun = true)
        : (this.v.v_id_pun = false);
      if (this.v.v_obs || this.v.v_id_pun) {
        Snackbar.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerPuntos();
  },
  data() {
    return {
      msg: "IncidenciasNueva",
      puntos: [],
      incidencia: {
        obs_ipu: null,
        id_pun_ipu: null
      },
      v: {
        v_id_pun: null,
        v_obs: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// IncidenciasNueva.vue?94c41b6a